var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo.svg",
    clipPath: "url(#clip0_1_6632)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 20,
    fill: "#413DF6",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5074 6.70901L12.3111 9.71817L2.57617 0.298828H8.69247L15.5074 6.70901Z",
    fill: "#413DF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3111 9.71777L15.5074 12.8054L8.97926 19.1162H2.57617L12.3111 9.71777Z",
    fill: "#413DF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.4335 0.298828L18.6985 9.71817L15.5073 12.8058L12.311 9.71817L15.5073 6.70901L22.3172 0.298828H28.4335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.14646 8.07227H0V11.5098H5.14646V8.07227Z",
    fill: "#413DF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.0092 8.07227H25.8628V11.5098H31.0092V8.07227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.4335 19.1161H22.0304L15.5073 12.8053L12.311 9.71766L15.5073 6.7085L18.6985 9.71766L28.4335 19.1161Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.8b2bb7ce8de0848fa0037633179260b8.svg";
export { ForwardRef as ReactComponent };